import { Box, Typography } from '@mui/material';

// Single source for the "Powered by <Prozo logo>" mark used across every template header/footer
// and the TopBar. labelSx styles the "Powered by" text; logoHeight sizes the prozo logo image.
// Replaces 6 hand-written, drifting copies (incl. the one that shipped as plain text).
export default function PoweredBy({ logoHeight = 24, labelSx }) {
    return (
        <Typography component="span" variant="body2"
            sx={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap', color: '#000', fontWeight: 500, ...labelSx }}>
            Powered by
            <Box component="img" src="/img/prozo.png" alt="Proship" sx={{ ml: 1, height: logoHeight, display: 'block' }} />
        </Typography>
    );
}
